import {useRef, useEffect, useState} from 'react';
import axios from 'axios';
import paths from '../../../assets/paths.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faHeartPulse, faImage, faCamera, faTerminal, faCode, faFileLines} from '@fortawesome/free-solid-svg-icons';
//import './commandsPanel.css'; //Kreios was here 8 

// A Panel that handles all API commands to remote computer and displays output
function CommandsPanel(props) {

    const [terminalCommands, setTerminalCommands] = useState([]);

    const ref = useRef(null);

     const clearCommands = async() => {
        const commandsList = document.getElementById("commandslist");
        while(commandsList.hasChildNodes()) {
            commandsList.removeChild(commandsList.firstChild);
            terminalCommands.pop();
        }
     }

    // Function handles all different API calls and displays their response message on the DOM
    const apiRequest = async(command) => {
        try {
            // Grabs login token and creates request object for axios call
            const route = command;

            const requestObject = {
                url: `${props.props.url}${paths[route].path}`,
                method: paths[route].method,
            }

            // if Commmand is not status add apiKey to headers
            if(route !== "status") {
                requestObject.headers = {"apiKey": props.props.deviceData.apiKey};
            }

            // if Commmand is screenshot set responseType to arrayBuffer
            if(route === "screenshot") {
                requestObject.responseType = "json";
            }

            // if Command is 'hasData' add data property to requestObject
            if(paths[route].hasData === true) {
                requestObject.data = {"cmd": terminalCommands};
            }

            // Executes API call to remote device
            const apiResponse = await axios(requestObject);

            // if call was successful set message in output panel and screenshot data too
            if(apiResponse.status === 200) {
                if(command === "screenshot" || command === "terminal") {
                    //alert("Screenshot Successfully fetched");
                    if(command === "terminal") {
                        const message = document.createElement('li');
                        message.classList = "border-bottom p-2";
                        message.innerText = `Executed Terminal commands: [${terminalCommands}]`;
                        document.getElementById('outputbox').append(message);
                    }
                    const message = document.createElement('li');
                    message.classList = "border-bottom p-2";
                    message.innerText = `Screenshot Successfully fetched | ${new Date(Date.now()).toLocaleString()}`;
                    document.getElementById('outputbox').append(message);
                    //console.log(apiResponse.data.data.buffer.data);
                    const base64 = btoa([].reduce.call(new Uint8Array(apiResponse.data.data.buffer.data),function(p,c){return p+String.fromCharCode(c)},''))
                    //console.log(base64);
                    document.querySelector("img").src = 'data:image/png;base64,' + base64;
                } else if(command === 'logs') {
                    // Sets Data to be put in Output box
                    const message = document.createElement('li');
                    message.classList = "border-bottom p-2";
                    message.innerText = `Successfully fetched logs | ${new Date(Date.now()).toLocaleString()}`;
                    document.getElementById('outputbox').append(message);

                    // Sets Data to be put in Logs box
                    for(let i = 0; i < apiResponse.data.length; i++) {
                        const log = document.createElement('li');
                        log.classList = "d-flex flex-column border-bottom p-2";

                        let address = document.createElement("span");
                        address.style = "";
                        address.innerText = apiResponse.data[i].remoteAddress;

                        let termCmd = document.createElement("span");
                        termCmd.classList = "";
                        termCmd.innerText = apiResponse.data[i].termCmd;

                        let body = document.createElement("span");
                        body.classList = "";
                        body.innerText = apiResponse.data[i].body;

                        let routePath = document.createElement("span");
                        routePath.classList = "";
                        routePath.innerText = apiResponse.data[i].routePath;

                        let time = document.createElement("span");
                        time.classList = "";
                        time.innerText = apiResponse.data[i].time;

                        log.append(address);
                        log.append(termCmd);
                        log.append(body);
                        log.append(routePath);
                        log.append(time);
                        document.getElementById('logsbox').append(log);
                    }
                    document.getElementById('logsbox').scrollTop = document.getElementById('logsbox').scrollHeight;
                } else {
                    //alert(apiResponse.data.message);
                    const message = document.createElement('li');
                    message.classList = "border-bottom p-2";
                    message.innerText = `${apiResponse.data.message} | ${new Date(Date.now()).toLocaleString()}`;
                    document.getElementById('outputbox').append(message);
                }
            } else {
                // Will probably need to expand on this in the future
                alert("ERROR Something went wrong, please try again");
            }
        } catch (err) {
            console.log(err);
        }
    }

    // May need to use later
    useEffect(() => {
        // Function handle adding a terminal command to request body of API call
        const handleSubmit = (e) => {
            e.preventDefault();

            terminalCommands.push(e.target.command.value);

            const badge = document.createElement("span");
            badge.classList = "";
            badge.innerText = e.target.command.value;
            
            const arrowElm = document.createElement("span");
            arrowElm.classList = "";
            arrowElm.innerText = ">";
            
            document.getElementById("commandslist").append(badge);
            document.getElementById("commandslist").append(arrowElm);
        };

        const element = ref.current;
        
        element.addEventListener('submit', handleSubmit);

        return () => {
            element.removeEventListener('submit', handleSubmit);
        };
    },[]);

    return(
        <article className='' style={{maxHeight: "250px"}}>
            <section className=''>
                <h5>Commands:</h5>
            </section>
            <section className=''>
                <button className='' style={{backgroundColor: "hotpink"}} onClick={() => apiRequest("status")} data-toggle="tooltip" data-placement="bottom" title="Status of Computer"><FontAwesomeIcon icon={faHeartPulse} size='2xl' /></button>
                <button className='' onClick={() => apiRequest("screenshot")} data-toggle="tooltip" data-placement="bottom" title="Screenshot"><FontAwesomeIcon icon={faImage} size='2xl' /></button>
                <button className="" style={{borderColor: "#07f22f"}} data-bs-toggle="modal" data-bs-target="#exampleModal" data-toggle="tooltip" data-placement="bottom" title="Terminal"><FontAwesomeIcon icon={faTerminal} size='2xl' style={{color: "#07f22f"}} /></button>
                <button className='' onClick={() => apiRequest("camera")} value='camera' data-toggle="tooltip" data-placement="bottom" title="Turn on Camera"><FontAwesomeIcon icon={faCamera} size='2xl' /></button>
                <button className='' onClick={() => alert("Shell command is not available Yet")} value='shell' data-toggle="tooltip" data-placement="bottom" title="Use Shell"><FontAwesomeIcon icon={faCode} size='2xl' style={{color: "ivory"}} /></button>
                <button className='' onClick={() => apiRequest("logs")} value='logs' data-toggle="tooltip" data-placement="bottom" title="Get Logs"><FontAwesomeIcon icon={faFileLines} size='2xl' /></button>
            </section>

            {/* 
                Below is Modal for Entering Terminal and Shell Commands 
                Will need to put it into its own component file
            */}
            <section className="" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="">
                    <div className="">
                    <div className="">
                        <h1 className="" id="exampleModalLabel">Enter Commands</h1>
                        <button type="button" className="" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="">
                        <form className="" ref={ref}>
                            <input type="text" name='command' placeholder='(e.g.) cd desktop' />
                            <button type='submit' className=''><FontAwesomeIcon icon={faPlus} size='xl' /></button>
                        </form>
                        <section id='commandslist' className='' style={{maxWidth:"500px", maxHeight: "220px", overflowX: "hidden"}}></section>
                    </div>
                    <div className="">
                        <div>
                            <button className='' onClick={clearCommands}>Clear</button>
                        </div>
                        <div>
                            <button type="button" className="" data-bs-dismiss="modal">Close</button>
                            <button type="button" className="" value='terminal' onClick={() => apiRequest("terminal")}>Send request</button>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        </article>
    );
}

export default CommandsPanel;
